import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Col, Flex, Form, Input, Row, Typography } from 'antd';

// components
import ComponentHeader from 'components/componentHeader/componentHeader';

// services
import { checkPhoneValidation } from 'utils/validators/phone';

// models
import { PhoneInputReturn } from 'components/phoneInput/phoneInput';
import FormPassword from 'components/formPassword/formPassword';

const ProfileChangePasswordComponent: FunctionComponent = () => {
	const { t } = useTranslation();

	const [profileForm] = Form.useForm();
	const [isLoading, setIsLoading] = useState(false);

	type FieldType = {
		name: string;
		email: string;
		phone: string;
	};

	const onChangePhone = ({ dialCode, number }: PhoneInputReturn) => {
		profileForm.setFieldsValue({
			phone: dialCode + number,
		});
	};

	const validatePhone = (_: any, value: any) => {
		// if (checkPhoneValidation(value)) {
		// 	return Promise.resolve();
		// } else if (value) return Promise.reject(new Error(t('COMMON.PHONE_INVALID')));
		// else return Promise.reject();
	};

	return (
		<>
			<Card>
				<Row>
					<Col span={24} lg={8}>
						<ComponentHeader title={t('PROFILE.SYSTEM_ADMIN_INF')} subtitle={t('PROFILE.UPDATE_YOUR_PERSONAL_DETAILS')} />
					</Col>
					<Col span={24} lg={10}>
						<Form form={profileForm}>
							<Row gutter={[16, 16]}>
								<Col span={24}>
									<FormPassword
										fullWidth
										name="password"
										label={t('COMMON.CURRENT_PASSWORD')}
										rules={[{ required: true, message: t('COMMON.PASSWORD_REQUIRED') }]}
									/>
								</Col>

								<Col span={24}>
									<FormPassword
										fullWidth
										name="password"
										label={t('COMMON.PASSWORD')}
										rules={[{ required: true, message: t('COMMON.PASSWORD_REQUIRED') }]}
									/>
								</Col>
								<Col span={24}>
									<FormPassword
										fullWidth
										name="password"
										label={t('COMMON.PASSWORD_CONFIRMATION')}
										rules={[{ required: true, message: t('COMMON.PASSWORD_REQUIRED') }]}
									/>
								</Col>

								<Col span={24}>
									<Form.Item style={{ marginTop: 20, maxWidth: 'unset' }}>
										<Button block type="primary" htmlType="submit" loading={isLoading}>
											{t('COMMON.UPDATE')}
										</Button>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
			</Card>
		</>
	);
};

export default ProfileChangePasswordComponent;
